import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function NotAuthorized() {
    return (
        <>
            <Helmet>
                <title>Non autorizzato</title>
            </Helmet>
            <main className="lv-shell lv-stack">
                <section className="lv-card lv-card-pad">
                    <div className="lv-empty">
                        <div className="lv-empty-icon">
                            <FontAwesomeIcon icon={['fas', 'lock']} />
                        </div>
                        <h2 className="lv-title mb-2">Accesso non consentito</h2>
                        <p className="lv-subtitle mb-4">Il tuo profilo non è ancora stato approvato dall&apos;amministratore.</p>
                        <Link to="/prenota" className="lv-btn lv-btn-primary lv-btn-pill">Vai al calendario</Link>
                    </div>
                </section>
            </main>
        </>
    );
}
